import React from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';

export const AboutPage = () => {
  return (
    <div className="min-h-screen" style={{ paddingTop: '120px' }}>
      <div className="container mx-auto px-4 max-w-4xl">
        <h1 className="display-medium text-white mb-8 text-center">About AFCON 2025</h1>
        
        <div className="network-card mb-8">
          <h2 className="heading-3 text-white mb-4">Our Mission</h2>
          <p className="body-medium text-gray-300 mb-4">
            AFCON 2025 Morocco is your comprehensive source for Africa Cup of Nations coverage. We provide live scores, 
            match schedules, team information, and official highlights to football fans around the world.
          </p>
          <p className="body-medium text-gray-300">
            Our goal is to bring the excitement of African football to fans everywhere, while maintaining the highest 
            standards of content quality and user experience.
          </p>
        </div>

        <div className="network-card mb-8">
          <h2 className="heading-3 text-white mb-4">What We Offer</h2>
          <ul className="space-y-3 text-gray-300">
            <li className="flex items-start gap-3">
              <span className="text-[var(--brand-primary)] mt-1">•</span>
              <span>Live match scores and real-time updates</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[var(--brand-primary)] mt-1">•</span>
              <span>Comprehensive tournament schedules and fixtures</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[var(--brand-primary)] mt-1">•</span>
              <span>Team profiles, group standings, and statistics</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[var(--brand-primary)] mt-1">•</span>
              <span>Official match highlights from authorized sources</span>
            </li>
            <li className="flex items-start gap-3">
              <span className="text-[var(--brand-primary)] mt-1">•</span>
              <span>Links to official broadcasters for live streaming</span>
            </li>
          </ul>
        </div>

        <div className="network-card">
          <h2 className="heading-3 text-white mb-4">Disclaimer</h2>
          <p className="body-small text-gray-400">
            This website is an independent fan site and is not affiliated with CAF (Confédération Africaine de Football), 
            the Morocco Football Federation, or any official AFCON organizers. All trademarks, logos, and images are property 
            of their respective owners. 
          </p>
        </div>
      </div>
    </div>
  );
};
